import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Space, List, Image, TabBar, Dialog, Input, Popup } from "antd-mobile";
import { List as VirtualizedList, AutoSizer } from 'react-virtualized'
import { getCurSelectedBook, setCurSelectedBook, downloadGrammaBook } from '../../../utils/states.js'
import styles from './My.module.css'
import './my.css'

const img_book_open = require('../../../assets/book_open.png')
const img_book_close = require('../../../assets/book_close.png')

const states = require("../../../utils/states.js")


const listPercentage = 0.9
const listShift = 200
var rowCount = 0
var inputCallback;

// const item = {
//   avatar: img_book_close,
//   name: 'item.name',
//   description: 'item.description',
// }
// var bookData = Array(rowCount).fill(item)
var bookData = [];
var cur_index = -1  //-1为初始值:未选择,-2为语法本
var firstInit = true;
var loading = true;

export default function My(props) {
  const navigate = useNavigate();
  const [trig, setTrig] = useState(1);
  const [inputV, setInputV] = useState('');
  const [popVisible, setPopVisible] = useState(false);
  const downLoadBookData = async (needDownload) => {
    bookData = await states.getBookList(needDownload);
    bookData.forEach(item => { item.avatar = img_book_close });
    rowCount = bookData.length;
  }
  if (firstInit) {
    firstInit = false;
    async function fetchData() {
      try {
        await downLoadBookData(false);
      } catch (err) {
        console.error(err);
      } finally {
        cur_index = getCurSelectedBook()
        if (cur_index > bookData.length - 1) {
          setCurSelectedBook(-1);
          cur_index = -1;
        }
        if (cur_index >= 0) {
          var d = bookData[cur_index];
          var data = {
            avatar: img_book_open,
            name: d.name,
            description: d.description
          }
          bookData[cur_index] = data
        }
        loading = false;
        setTrig(trig + 1)
      }
    }
    fetchData();
  }

  //#region 视口信息 -----
  // 根据视口高度动态计算列表高度 (60vh)
  const [listHeight, setListHeight] = useState(() => window.innerHeight * listPercentage - listShift);
  useEffect(() => {
    // 窗口尺寸变化时更新高度
    const handleResize = () => {
      setListHeight(window.innerHeight * listPercentage - listShift)
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  //#endregion =========


  // 单词本按钮回调函数
  function onClickGrammaBook() {
    if (cur_index === -1) return
    if (cur_index < bookData.length) {
      var n = bookData[cur_index].name
      var d = bookData[cur_index].description
      bookData[cur_index] = { avatar: img_book_close, name: n, description: d }
    }
    cur_index = -1
    setCurSelectedBook(-1)
    setTrig(trig + 1)
    console.log('index = ', cur_index)
  }
  function onClickListItem(index) {
    if (index === cur_index) return
    console.log('index = ', index)
    var n = bookData[index].name
    var d = bookData[index].description
    bookData[index] = { avatar: img_book_open, name: n, description: d }
    if (cur_index >= 0) {
      n = bookData[cur_index].name
      d = bookData[cur_index].description
      bookData[cur_index] = { avatar: img_book_close, name: n, description: d }
    }
    cur_index = index
    setCurSelectedBook(cur_index)
    setTrig(trig + 1)
  }
  function rowRenderer({ index, key, style }) {
    const item = bookData[index]
    return (
      <List.Item
        key={key}
        style={{ ...style, 'paddingTop': '10px' }}
        onClick={() => onClickListItem(index)}
        extra='extra info'
        prefix={
          <Image
            src={item.avatar}
            style={{ borderRadius: 20 }}
            fit='cover'
            width={40}
            height={40}
          />
        }
        description={item.description}
      >
        {item.name}
      </List.Item>
    )
  }

  //#region 底部按钮回调函数
  async function onLogout1() {
    var res = await Dialog.confirm({
      content: '确认退出？'
    })
    if (res) {
      localStorage.removeItem('jwt');
      navigate('/login', { replace: true }); // replace: true 表示不添加历史记录
    }
  }
  function onLogout() {
    onLogout1();
  }

  const onRefresh = async () => {
    await states.refreshData()
    await states.downloadGrammaTags()
    await states.downloadWordTagByBook()
  }
  async function addBookInput(value) {
    console.warn('添加BOOK ', value);
    //检查名称是否重复、为空
    let b = true;
    if (value === '') {
      b = false;
    } else {
      for (const item of bookData) {
        if (item.name === value) {
          b = false;
          break;
        }
      }
    }
    if (b) {//名称合法，继续
      if (await states.addBook(value)) {
        await downLoadBookData(true);
        if (cur_index >= 0) {
          var d = bookData[cur_index];
          var data = {
            avatar: img_book_open,
            name: d.name,
            description: d.description
          }
          bookData[cur_index] = data
        }
        setTrig(trig + 1);
      } else {
        Dialog.alert({ content: '添加失败，请查看控制台日志' });
      }
    } else {//名称不合法，跳个提示
      Dialog.alert({ content: '名称不合法' });
    }
  }
  const onAddBook = () => {
    setInputV('');
    inputCallback = addBookInput;
    setPopVisible(true);
  }

  //删除book
  const onDeleteBook = async () => {
    if (cur_index === -1) return;
    let b = await Dialog.confirm({ content: '确认删除？' });
    if (b) {
      if (await states.deleteBook(bookData[cur_index].name)) {
        await downLoadBookData(true);
        onClickGrammaBook();
        setTrig(trig + 1);
      } else {
        Dialog.alert({ content: '删除失败，请查看控制台' })
      }
      await downLoadBookData(true);
    }
  }

  //更名book
  async function renameBook(value) {
    console.warn('更名BOOK ', value);
    //检查名称是否重复、为空
    let b = true;
    if (value === '') {
      b = false;
    } else {
      for (const item of bookData) {
        console.log('item.name = ', item.name)
        if (item.name === value) {
          b = false;
          break;
        }
      }
    }
    console.warn('b=', b);
    if (b) {
      if (states.editBookName(bookData[cur_index].name, value)) {
        var book = structuredClone(bookData[cur_index]);
        book.name = value;
        bookData[cur_index] = book;
        setTrig(trig + 1);
      } else {
        Dialog.alert({ content: '发生错误，请查看控制台' });
      }

    } else {
      Dialog.alert({ content: '名称不合法' });
    }
  }
  const onRenameBook = () => {
    if (cur_index === -1) return;
    setInputV('');
    inputCallback = renameBook;
    setPopVisible(true);
  }

  //#endregion 底部按钮回调


  if (loading) {
    return (<div>加载中...</div>)
  }
  return (<div className={styles.my}>
    <div className={styles.header}>
      <h2 style={{ 'margin': 0 }}>我的ID : {props.username} </h2>
      <div style={{ display: 'flex', width: '30%' }} />
      <Button onClick={onLogout} style={{ 'margin': '0px' }}>退出登录</Button>

    </div>

    <div className={styles.btnGramma}>
      <Button block color={cur_index === -1 ? 'primary' : 'default'} size='middle'
        onClick={onClickGrammaBook} >语法本</Button>
    </div>


    <div className={styles.list} trig={trig}>
      <List mode="card" header='单词本' >
        <AutoSizer disableHeight>
          {({ width }) => (
            <VirtualizedList
              rowCount={rowCount}
              rowRenderer={rowRenderer}
              width={width}
              height={listHeight}
              rowHeight={60}
              overscanRowCount={10}
            />
          )}
        </AutoSizer>
      </List>
    </div>
    <div className={styles.btnBottom}>
      <Button onClick={onDeleteBook} style={{ width: '20%', padding: '5px' }}>删除</Button>
      <Button onClick={onAddBook} style={{ width: '20%', padding: '5px' }}>添加</Button>
      <Button onClick={onRenameBook} style={{ width: '20%', padding: '5px' }}>更名</Button>
      <Button onClick={onRefresh} style={{ width: '20%', padding: '5px' }}>刷新</Button>
    </div>

    {/* 显示输入框 */}
    <div>
      <Popup
        visible={popVisible}
        onMaskClick={() => { setPopVisible(false) }}
        onClose={() => { setPopVisible(false) }}
        bodyStyle={{ height: '20vh' }}
      >
        <Input
          style={{
            'padding': '10px', 'margin': '10%', 'marginBottom': '3%',
            'backgroundColor': '#f9f4d8ff', 'width': '80%'
          }}
          placeholder="请输入名称"
          value={inputV}
          onChange={(val) => { setInputV(val) }}
        />
        <div style={{ 'display': 'flex', 'justifyContent': 'center', 'gap': '12px', 'padding': '42px' }}>
          <Button style={{ flex: 1 }} onClick={() => {
            setPopVisible(false);
          }}>取消</Button>
          <Button style={{ flex: 1 }} color="primary" onClick={() => {
            inputCallback?.(inputV);
            setPopVisible(false);
          }}>确认</Button>
        </div>
      </Popup>
    </div>

  </div >)

}